import React from "react";

function GoogleMap() {
  return (
    <div className="px-4 pt-80 pb-80">
        <div
        style={{
            maxWidth: "100%",
            listStyle: "none",
            transition: "none",
            overflow: "hidden",
            width: "100%",
            height: "500px",
        }}
        >
        <div
            id="canvas-for-googlemap"
            style={{
            height: "100%",
            width: "100%",
            maxWidth: "100%",
            }}
        >
            <iframe
            title="Google Map"
            style={{
                height: "100%",
                width: "100%",
                border: "0",
            }}
            frameBorder="0"
            src="https://www.google.com/maps/embed/v1/place?q=sunnyside+blantyre+Malawi&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
            allowFullScreen
            ></iframe>
        </div>
        <a
            className="googl-ehtml"
            rel="nofollow"
            href="https://www.bootstrapskins.com/themes"
            id="enable-maps-data"
        >
            Premium Bootstrap Themes
        </a>
        <style>
            {`
            #canvas-for-googlemap img {
                max-width: none !important;
                background: none !important;
                font-size: inherit;
                font-weight: inherit;
            }
            `}
        </style>
        </div>
    </div>
        
  );
}

export default GoogleMap;
